import React, { useState, useEffect } from "react";
import API_BASE_URL from "../api";
import { authFetch } from "../authFetch";
import { useAuth } from "../authContext";
import { useTranslation } from 'react-i18next';

const DEMO_EMAIL = "demo@radiomonitor.net";

export default function ProfilePage() {
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [resetMessage, setResetMessage] = useState(null);
  const { isAuth, user } = useAuth();
  const { t } = useTranslation('common');
  const API = (API_BASE_URL || "").replace(/\/+$/, "");

  useEffect(() => {
    if (!isAuth) {
      setProfile(null);
      setLoadingProfile(false);
      return;
    }
    setLoadingProfile(true);
    authFetch(`${API}/profile`)
      .then((r) => r.json())
      .then((data) => {
        setProfile({
          email: data.email,
          name: data.name,
          confirmed: data.is_confirmed,
        });
        setLoadingProfile(false);
      })
      .catch(() => {
        setProfile(null);
        setLoadingProfile(false);
      });
  }, [isAuth, API]);

  // Сброс пароля
  const handleRequestPasswordReset = async () => {
    setResetMessage(null);
    const rawEmail = String(user?.email || profile?.email || '').trim();
    const emailLower = rawEmail.toLowerCase();

    if (!rawEmail) {
      setResetMessage(t('profile.reset_error'));
      return;
    }

    if (emailLower === DEMO_EMAIL) {
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('demo:block', {
          detail: { action: 'reset_password', source: 'profile' }
        }));
      }
      return;
    }

    try {
      const response = await authFetch(`${API}/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: rawEmail }),
      });

      if (response.ok) {
        setResetMessage(t('profile.reset_sent'));
        return;
      }

      if (response.status === 403) {
        let data = {};
        try { data = await response.json(); } catch {}
        const detail = data?.detail;
        const code = data?.code || detail?.code || detail?.error;
        if (code === 'DEMO_ADD_BLOCKED') {
          if (typeof window !== 'undefined' && window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('demo:block', {
              detail: { action: 'reset_password', source: 'profile' }
            }));
          }
          return;
        }
      }

      setResetMessage(t('profile.reset_error'));
    } catch {
      setResetMessage(t('profile.reset_error'));
    }
  };

  return (
    <div
      style={{
        maxWidth: 470,
        margin: "42px auto",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0001",
        padding: "0 0 36px 0",
        fontFamily: "inherit"
      }}
    >
      <div
        style={{
          background: "#00723a",
          color: "#fff",
          padding: "22px 32px",
          borderRadius: "16px 16px 0 0",
          fontWeight: 700,
          fontSize: 30,
          letterSpacing: 0.5
        }}
      >
        {t('profile.title')}
      </div>
      <div style={{ padding: "32px 34px 0 34px" }}>
        {loadingProfile ? (
          <div style={{ color: "#888", fontSize: 18 }}>{t('profile.loading')}</div>
        ) : !profile ? (
          <div style={{ color: "#e54848", fontSize: 18 }}>{t('profile.not_found')}</div>
        ) : (
          <>
            <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 20, lineHeight: "2" }}>
              <b>{t('profile.labels.email')}:</b> <span style={{ fontWeight: 400 }}>{profile.email}</span>
              <br />
              <b>{t('profile.labels.name')}:</b> <span style={{ fontWeight: 400 }}>{profile.name}</span>
              <br />
              <b>{t('profile.labels.confirmed')}:</b> <span style={{ fontWeight: 400 }}>{profile.confirmed ? t('profile.confirmed_yes') : t('profile.confirmed_no')}</span>
            </div>

            <hr style={{ margin: "24px 0 24px 0", border: 0, borderTop: "1px solid #eee" }} />
            <button
              style={{
                width: "100%",
                padding: "14px 0",
                fontSize: 18,
                borderRadius: 8,
                border: "none",
                background: "#00723a",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
                marginBottom: 6,
                letterSpacing: 0.5
              }}
              onClick={handleRequestPasswordReset}
            >
              {t('profile.reset_button')}
            </button>
            {resetMessage && (
              <div
                style={{
                  background: "#00723a",
                  color: "#fff",
                  borderRadius: 14,
                  padding: "30px 22px 28px 22px",
                  textAlign: "center",
                  marginTop: 18,
                  boxShadow: "0 2px 12px #0001"
                }}
              >
                <div style={{ fontSize: 20, marginBottom: 18 }}>
                  {resetMessage}
                </div>
                <button
                  style={{
                    minWidth: 120,
                    padding: "12px 0",
                    background: "#fff",
                    color: "#00723a",
                    borderRadius: 7,
                    border: "none",
                    fontSize: 17,
                    fontWeight: 700,
                    cursor: "pointer",
                    marginTop: 8,
                    letterSpacing: 0.5
                  }}
                  onClick={() => setResetMessage(null)}
                >
                  {t('ok')}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
